// 'use strict';
// npm install --save-dev @babel/core @babel/cli @babel/preset-env
const meses = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
const main = () => {
	let _cp = document.body.dataset.page;
	if (window[_cp] && typeof window[_cp] === 'function') {
		window[_cp]();
	}
};

document.addEventListener('DOMContentLoaded', main, !1);